





































declare let showPrices;
declare let showPricesSelector;
declare let usePartners;
declare let useMyBaumitUser;

import Vue from "vue";
import {Component, Watch, Emit} from "vue-property-decorator";
import {translate} from "../../services/translation/translation";
import {get, getCalculator, getPdf} from '../../services/webclient/webclient';
import CalcSelectorPage from '../calc-selector-page/calc-selector-page.vue';
import QuestionsPage from '../questions-page/questions-page.vue';
import PreviewCalculationPage from "@/components/product-selector-page/product-selector-page.vue";
import ProductSelectorPage from "@/components/product-selector-page/product-selector-page.vue";
import detailsPage from "@/components/details-page/details-page.vue";
import {CalculatorRouteService} from "@/services/routing/calculator-route.service";
import GettingDiscount from "@/components/getting-discount/getting-discount.vue";
import ThankYou from "@/components/thank-you/thank-you.vue";
import './_calculator.less';

@Component({
    components: {
        CalcSelectorPage,
        QuestionsPage,
        ProductSelectorPage,
        detailsPage,
        GettingDiscount,
        ThankYou,
    }
})

export default class calculator extends Vue {
    private data: any = {
        pages: [
            {index: 0, name: "calc-selector-page"},
            {index: 1, name: "questions-page"},
            {index: 2, name: "product-selector-page"},
            {index: 3, name: "details-page"},
            {index: 4, name: "getting-discount"},
            {index: 5, name: "thank-you"}
        ],
        currentPage: 'calc-selector-page',
        currentPageIndex: 0,
        calculatorDefaulSystem: {},
        sendingProductsData: {},
        sendingAnswerData: {},
        selectedAnswer: {},
        sendYourData: {},
        resetQuestionEngine: false,
        selectedCalc: '',
        selectedName: '',
        showPrices: true,
        showPricesSelector: true,
        usePartners: true,
        useMyBaumitUser: false,
    };

    mounted() {
        this.data.showPrices = showPrices;
        this.data.showPricesSelector = showPricesSelector;
        this.data.usePartners = usePartners;
        this.data.useMyBaumitUser = useMyBaumitUser;
        CalculatorRouteService.instance.urlChanged.subscribe(obj => {
            if (obj.step == 0 && obj.calcId > -1) {
                this.data.currentPageIndex = 0;
                this.data.currentPage = this.data.pages[this.data.currentPageIndex].name;
                this.onSelectedCalc(obj.calcId);
            } else {
                this.data.currentPageIndex = obj.step;
                this.data.currentPage = this.data.pages[this.data.currentPageIndex].name;
                if(this.data.selectedName == "" && this.data.selectedCalc != ""){
                    this.data.selectedName = " ";
                    getCalculator(this.data.selectedCalc).then(data=>{
                        this.data.selectedName = data.calculator.name;
                    })
                }
            }
        });

    }


    trans(key) {
        return translate(key);
    }


    @Watch("selectedAnswer", {immediate: true, deep: true})
    onSelectedAnswer(value) {
        if (!$.isEmptyObject(value)) {
            this.data.selectedAnswer = value;
            this.nextPage();
        }
    }


    @Watch("selectedCalc", {immediate: true, deep: true})
    onSelectedCalc(id) {
        if (id !== undefined) {
            if (this.data.selectedCalc != id && this.data.selectedCalc != "") {
                this.data.resetQuestionEngine = true;
            } else {
                this.data.resetQuestionEngine = false;
            }
            this.data.selectedCalc = id;
            this.nextPage();
        }

    }

    @Watch("slectCalcName", {immediate: true, deep: true})
    onSelectCalcName(name) {
        if (name !== undefined) {
            this.data.selectedName = name;
        }

    }

    @Watch("selectedDetails", {immediate: true, deep: true})
    onSelectedDetails(systemId) {
        if (systemId !== undefined) {
            this.data.systemId = systemId;
            this.nextPage();
        }

    }

    @Watch("getCalculatorDefaulSystem", {immediate: true, deep: true})
    onGetCalculatorDefaulSystem(value) {
        if (value !== undefined) {
            this.data.calculatorDefaulSystem = value;
        }

    }

    @Watch("goToDiscounts", {immediate: true, deep: true})
    onGoToDiscounts(id) {
        if (id !== undefined) {
            this.nextPage();
        }

    }

    @Watch("backToProduct", {immediate: true, deep: true})
    onBackToProduct(id) {
        if (id !== undefined) {
            this.nextPageTo(2);
        }

    }

    @Watch("backToCalcSelector", {immediate: true, deep: true})
    onBackToCalcSelector(id) {
        if (id !== undefined) {
            this.nextPageTo(-1);
        }

    }

    @Watch("sendYourData", {immediate: true, deep: true})
    onSendYourData(data) {
        if (data !== undefined) {
            this.data.sendYourData = data;
        }

    }

    @Watch("sendProducts", {immediate: true, deep: true})
    onSendProducts(data) {
        if (data !== undefined) {
            this.data.sendingProductsData = data;
        }
    }

    @Watch("sendAnswerData", {immediate: true, deep: true})
    onSendAnswerData(data) {
        if (data !== undefined) {
            this.data.sendingAnswerData = data;
        }
    }

    @Watch("goToDiscountsFromSelector", {immediate: true, deep: true})
    onGoToDiscountsFromSelector(data/*system, data*/) {
        if (data && data.data !== undefined) {
            this.data.sendingAnswerData = data.data;
            this.data.sendYourData = data.data;
            this.nextPageTo(4);
        }
    }

    @Watch("nextToThanks", {immediate: true, deep: true})
    onNextToThanks(data) {
        if (data !== undefined) {
            this.nextPageTo(5);
        }
    }

    @Watch("backToQuestions", {immediate: true, deep: true})
    onBackToQuestions(data) {
        if (data !== undefined) {
            this.nextPageTo(1);
        }
    }

    public nextPage() {
        CalculatorRouteService.instance.pushStep(this.data.currentPageIndex + 1, this.data.selectedCalc);
    }

    public nextPageTo(id) {
        if(id == -1){
            id = 0;
            this.data.currentPageIndex = 0;
            this.data.selectedCalc = -1;
        }
        CalculatorRouteService.instance.replaceStep(id, this.data.selectedCalc);
    }

    public prevPage() {
        CalculatorRouteService.instance.back();
    }


}

